'use client';

import { useParams } from 'next/navigation';
import { useCallback } from 'react';
import {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  type FormatDateInput,
  formatDate as formatDateUtil,
} from '@/utils/format-date';

export const useFormatDate = () => {
  const params = useParams<{ locale?: string }>();
  const locale = params?.locale;

  const formatDateTime = useCallback(
    (date: FormatDateInput, format: string = DATE_TIME_FORMAT) =>
      formatDateUtil(date, locale, format),
    [locale],
  );

  const formatDateOnly = useCallback(
    (date: FormatDateInput, format: string = DATE_FORMAT) => formatDateUtil(date, locale, format),
    [locale],
  );

  return { formatDateTime, formatDateOnly };
};

export default useFormatDate;
